import { useMutation } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { UserProductTypes } from '@/types';

export const deleteUserIncompleteProduct = ({
  groupId,
}: {
  groupId: string;
}): Promise<UserProductTypes[]> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'payment/' + groupId;
  return axios.delete(endPoint).then((response: any) => {
    return response.data;
  });
};

type UseDeleteUserIncompleteProductOptions = {
  config?: MutationConfig<typeof deleteUserIncompleteProduct>;
};

export const useDeleteUserIncompleteProduct = ({
  config,
}: UseDeleteUserIncompleteProductOptions = {}) => {
  return useMutation({
    onMutate: async (creatingNotification: any) => {
      await queryClient.cancelQueries(['payment', creatingNotification]);

      const previousDetails = queryClient.getQueryData<UserProductTypes>([
        'payment',
        creatingNotification,
      ]);

      queryClient.setQueryData(['payment', creatingNotification], {
        ...previousDetails,
        ...creatingNotification.data,
      });

      return { previousDetails: previousDetails };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(['payment', context.previousDetails], context.previousDetails);
      }
    },
    onSuccess: (data) => {
      return queryClient.refetchQueries(['payment', data]);
    },
    ...config,
    mutationFn: deleteUserIncompleteProduct,
  });
};
